import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XDiv, XImage, XText } from "IZOX/_X";
import HTMLReactParser from "html-react-parser";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class ServiceDesc extends Component {

  static propTypes = {
    info: PropsType.object
  }

  static defaultProps = {
    info: {}
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ServiceDesc.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  renderContent(){
    let {info} = this.props;
    let {title, content} = info?.service ?? {};
    return (
      <VStack spacing={16} width={630}>
        <XText fullWidth textAlign="[" color={ColorX.CSS("Grass")} bold fontSize={32}>
          {LocaleX.Parse({
            EN: "Service",
            TC: "服務"
          })}
        </XText>
        <XText fullWidth textAlign="[" color={ColorX.CSS("TextBlue")} bold fontSize={22}>
          {LocaleX.Parse(title)}
        </XText>
        <XText fullWidth fontSize={16}>
          {HTMLReactParser(LocaleX.Parse(content))}
        </XText>
      </VStack>
    );
  }

  renderPics(){
    let {info} = this.props;
    let {pic} = info?.service ?? {};
    return (
      <XDiv width={526} height={541} position="relative">
        <XDiv position="absolute" style={{ top: 0, left: 426 }}
          width={80} height={80} bgColor={ColorX.CSS("Yolk")}/>
        <XDiv position="absolute" style={{ bottom: 0, left: 184 }}
          width={378} height={378} bgColor={ColorX.CSS("Grass")}/>
        <XDiv position="absolute" style={{ bottom: 60, left: 0 }}
          width={68} height={68} bgColor={ColorX.CSS("DeepBlueSea")}/>
        <XImage position="absolute" source={pic} 
          noResize width={417} height={417}
          style={{ top: 36, left: 38 }}/>
      </XDiv>
    );
  }

  renderNormal(){
    return (
      <HStack pH={80} spacing={124} mB={80}>
        {this.renderContent()}
        {this.renderPics()}
      </HStack>
    );
  }

  renderPicsM(){
    let {info} = this.props;
    let {pic} = info?.service ?? {};
    return (
      <XDiv style={{transform: `scale(${Math.min(1, window.innerWidth * 0.9 / 526)})`}} mT={10}
        fitWidthToContent fitHeightToContent overflow="visible">
        <XDiv height={541} width={541} position="relative" overflow="visible">
          <XDiv position="fixed" style={{ top: 0, left: 426 }}
            width={80} height={80} bgColor={ColorX.CSS("Yolk")}/>
          <XDiv position="fixed" style={{ top: 200, left: 154 }}
            width={378} height={378} bgColor={ColorX.CSS("Grass")}/>
          <XDiv position="fixed" style={{ top: 410, left: 0 }}
            width={68} height={68} bgColor={ColorX.CSS("DeepBlueSea")}/>
          <XImage position="fixed" source={pic} 
            noResize width={417} height={417}
            style={{ top: 36, left: 38 }}/>
        </XDiv>
      </XDiv>
    );
  }

  renderContentM(){
    let {info} = this.props;
    let {title, content} = info?.service ?? {};
    return (
      <VStack spacing={16} fullWidth pH={60} >
        <HStack HAlign="[">
          <XText fullWidth textAlign="[" color={ColorX.CSS("Grass")} bold fontSize={32}>
            {LocaleX.Parse({
              EN: "Service",
              TC: "服務"
            })}
          </XText>
        </HStack>
        <HStack HAlign="[">
          <XText fullWidth textAlign="[" color={ColorX.CSS("TextBlue")} bold fontSize={22}>
            {LocaleX.Parse(title)}
          </XText>
        </HStack>
        <HStack HAlign="[">
          <XText fullWidth fontSize={16}>
            {HTMLReactParser(LocaleX.Parse(content))}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderMobile(){
    return (
      <VStack fullWidth mB={20}>
        {this.renderContentM()}
        {this.renderPicsM()}
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }



}

export default observer(ServiceDesc);
